// ── SectionTitle ──────────────────────────────────────────────────────────────
// Section heading used in Settings and Showcase pages.
// Uppercase, caption-weight label with bottom margin.

import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function SectionTitle({ children }: Props) {
  return (
    <h2
      className="text-xs font-medium mb-4"
      style={{
        fontFamily: 'var(--evo-font)',
        color: 'var(--evo-fg-3)',
        textTransform: 'uppercase',
        letterSpacing: '0.88px',
      }}
    >
      {children}
    </h2>
  );
}
